export default __webpack_public_path__ + "static/media/passtrack_header_color.37fec387.png";